import { useTranslation } from 'react-i18next';
import { TrashIcon } from '@utils/icons';
import { formatElapsed } from '../../../utils/formatElapsed';
import { Waveform } from './Waveform/Waveform';
import styles from './RecordingBar.module.css';

interface IRecordingBarProps {
  elapsedMs: number;
  getLevel: () => number;
  onCancel: () => void;
}

export function RecordingBar({ elapsedMs, getLevel, onCancel }: IRecordingBarProps) {
  const { t } = useTranslation();
  const time = formatElapsed(elapsedMs);

  return (
    <div className={styles.recordingBar}>
      <button
        type="button"
        className={styles.iconBtn}
        onClick={onCancel}
        aria-label={t('comms.composer.discardRecording')}
      >
        <TrashIcon size={15} />
      </button>
      <span className={styles.recordingDot} aria-hidden="true" />
      <span className={styles.recordingTime} role="timer" aria-label={t('comms.composer.recording', { time })}>
        {time}
      </span>
      <Waveform getLevel={getLevel} />
    </div>
  );
}
